import { inject } from 'vue';
import { useAppStore, useUserStore, useActionStore } from '@coreStores/index';
import { getLogoutUrl } from '@composable/useCommon';

export default () => {
    /* ------ Declaration ------ */
    const appStore = useAppStore();
    const userStore = useUserStore();
    const actionStore = useActionStore();

    /* ------ Methods ------ */
    const logout = inject('logout') as Function;

    /**
     * Logout action.
     */
    const onLogout = async (userType: string): Promise<void> => {
        if (!userStore.getLoggedIn()) {
            actionStore.setComponentAction('force-logout', true);
            return;
        }

        appStore.toggleLoader(true);

        if (userStore.getToken()) {
            logout(
                { user: userStore, action: actionStore },
                { action: getLogoutUrl(userType), token: userStore.getToken() }
            );
        }
    };

    return {
        onLogout
    };
};
